import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { getIn } from 'seamless-immutable';
import { Nav } from '@catalogo/core-nav';
import PlusSymbol from '@catalogo/ui-americanas-desktop-svg/plus-symbol.svg';
import ArrowRight from '@catalogo/ui-americanas-desktop-svg/arrow.svg';
import { getMoreOffersUrl } from './helpers';

export const MoreOffers = ({ offersQuantity, history, currentSku, product }) => {
  const { search: locationQuery } = getIn(history, ['location']);
  const { id: productId } = product;

  return (
    <Touchable to={getMoreOffersUrl(productId, currentSku, locationQuery)}>
      <ContentWrapper>
        <PlusSymbol fill="#666" direction="right" width="15" height="15" />
        <Text>{offersQuantity} outras ofertas deste mesmo produto</Text>
      </ContentWrapper>
      <div>
        <ArrowRight fill="#666" width="12" height="12" transform="rotate(270)" />
      </div>
    </Touchable>
  );
};

const Text = styled.span`
  margin-left: 10px;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Touchable = styled(Nav)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  &:hover {
    color: inherit;
  }

  svg {
    -webkit-transform: rotate(270deg);
  }
`;

MoreOffers.propTypes = {
  offersQuantity: propTypes.number,
  children: propTypes.object,
  href: propTypes.string,
};

export default withRouter(MoreOffers);
